import { BenefitStatus } from '@zorro/clients';
import { Space, Text } from '@zorro/web/design-system';
import { useIdempotencyKey, useMonolithMutation } from '@zorro/web/ui-utils';

import { ModalFooter } from '../ModalComponents/ModalFooter';

type Props = {
  benefitId: string;
  onClose: () => void;
};

export const UndoApplicationForm = ({ benefitId, onClose }: Props) => {
  const idempotencyKey = useIdempotencyKey();
  const { mutate: mutateBenefitStatus } = useMonolithMutation({
    method: 'benefitsControllerUpdateBenefitStatus',
  });

  const handleSubmit = async () => {
    await mutateBenefitStatus([
      benefitId,
      idempotencyKey.get(),
      { status: BenefitStatus.READY_TO_APPLY },
    ]);

    onClose();
  };

  return (
    <>
      <Text size="sm">
        The enrollment will be set back to election submitted status
      </Text>

      <Space h="xl" />
      <ModalFooter
        submitText="Change status"
        onSubmit={handleSubmit}
        onClose={onClose}
        submitVariant="primary"
      />
    </>
  );
};
